import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HelperService } from './../../../services/helper.service';
import { CollaboratorService } from './../../../rest/api/collaborator.service';
@Component({
  selector: 'app-register-collaborator',
  templateUrl: './register-collaborator.component.html',
  styleUrls: ['./register-collaborator.component.scss']
})
export class RegisterCollaboratorComponent implements OnInit {
  @Input() token;
  @Input() tokenData;
  form: FormGroup;

  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: any;
  errorMsg: any;
  errMessage: any;

  constructor(
    public fb: FormBuilder,
    public collaboratorService: CollaboratorService,
    public helperService: HelperService,
    private route: ActivatedRoute,
    public router: Router,
  ) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      email: [{value: this.tokenData && this.tokenData.email ? this.tokenData.email : '', disabled: true},
        [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      first_name: ['', [Validators.required, Validators.maxLength(40)]],
      last_name: ['', [Validators.required, Validators.maxLength(40)]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(20)]],
    });
  }

  submit(value) {
    if (!this.form .valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    data.email = this.tokenData.email;
    data.token = this.token;
    this.submitApi(data);
  }

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }

  submitApi(data) {
    const formData = {
      first_name: data.first_name,
      last_name: data.last_name,
      password: data.password,
      token: data.token
    };
    data = this.helperService.updateJsonFormat(formData);
    this.collaboratorService.registerCollaborator(data).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'You are now activated as collaborator. You can now login as collaborator.';
      setTimeout(() => {
        this.router.navigate(['/login']);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }
  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.form.reset();
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'Unable to register at this time.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

}
